export const SITE_MODULATORS_TABLE_FRENCH_LOCALE = {
  headers: {
    modnum: "# Modnum",
    pilotHwId: "Pilote Hardware Id",
    serialNumber: "Numéro de série",
    way: "Voie",
    csId: "Cs Id",
    hwId: "Hardware Id",
    lastPilotConnectionDatetime: "Date dernière connexion du pilote",
    interpretedAcqRate: "Taux d'acquisition",
    linkedAppliance: "Appareil relié",
    installationDate: "Date d'installation",
  },
  empty: "Aucun modulateur trouvé...",
};
